import React from "react";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
  },
  header: {
    textAlign: "center",
    marginTop: 0,
    fontWeight: 500,
    fontSize: "0.937rem",
  },
  button: {
    minWidth: "76px",
    height: "76px",
    color: () => theme.palette.getContrastText(theme.palette.primary.main),
    border: "none",
    backgroundColor: (props) => theme.palette.primary.main,
    "&.selected": {
      backgroundColor: () => theme.palette.secondary.main,
      color: () => theme.palette.getContrastText(theme.palette.secondary.main),
    },
  },
  list: {
    listStyle: "none",
    overflow: "auto",
    display: "flex",
    flexWrap: "nowrap",
    padding: 0,
    margin: 0,
    textAlign: "center",
    "&::before, &::after": {
      content: '""' /* Insert pseudo-element */,
      margin: "auto",
    },
    "& > li": {
      display: "inline-block",
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
  },
}));

export const ToolbarOptionsHeader = ({
  children,
  includeContainer,
  header,
}) => {
  const classes = useStyles();

  const ret = <h3 className={classes.header}>{header}</h3>;
  if (includeContainer) {
    return (
      <div className={classes.container}>
        {ret}
        {children}
      </div>
    );
  }
  return ret;
};

export const ToolbarOptions = ({ children, header }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <ToolbarOptionsHeader header={header} />
      <ul className={classes.list}>{children}</ul>
    </div>
  );
};

export const ToolbarOption = ({
  content,
  selected,
  onClick,
  forwardRef,
  style,
  buttonStyle,
}) => {
  const classes = useStyles();
  return (
    <li ref={forwardRef} style={style}>
      <button
        style={buttonStyle}
        className={`${classes.button} ${selected ? "selected" : ""}`}
        onClick={onClick}
      >
        {content}
      </button>
    </li>
  );
};
